/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StripSpecialCharsPipe } from '@shared/utils/pipes';
import { HomefieldButtonModule } from '@homefield';
import { WysiwygModule } from '../wysiwyg/wysiwyg.module';
import { WysiwygDetailsComponent } from './wysiwyg-details.component';

@NgModule({
	imports: [CommonModule, HomefieldButtonModule, StripSpecialCharsPipe, WysiwygModule],
	declarations: [WysiwygDetailsComponent],
	bootstrap: [WysiwygDetailsComponent],
	exports: [WysiwygDetailsComponent]
})
export class WysiwygDetailsModule {}
